import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { EMAIL, LOCATION, NAV_ITEMS, PHONE_DISPLAY, scrollToSection } from '../constants';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="bg-bordeaux-dark text-cream border-t border-cream/10">
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-14 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <img src="/bitexpress-logo.png" alt="BiTExpress Logo" className="h-24 md:h-28 w-auto object-contain logo-footer-white" />
          <p className="mt-6 max-w-sm text-cream/60 leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div className="md:col-span-3">
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-gold">{t.footer.navigation}</h3>
          <ul className="mt-6 flex flex-col gap-3">
            {NAV_ITEMS.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => scrollToSection(item.id)}
                  data-testid={`footer-nav-${item.id}`}
                  className="text-cream/70 hover:text-gold text-sm"
                >
                  {t.nav[item.key]}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-gold">{t.footer.contact}</h3>
          <ul className="mt-6 flex flex-col gap-3 text-sm text-cream/70">
            <li data-testid="footer-phone">{PHONE_DISPLAY}</li>
            <li data-testid="footer-email">{EMAIL}</li>
            <li data-testid="footer-location">{LOCATION}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="mx-auto max-w-7xl px-6 md:px-12 py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-cream/50">
          <p data-testid="footer-copyright">© 2026 BiTExpress — {t.footer.rights}</p>
          <p className="font-heading italic text-cream/60">Abidjan · Afrique francophone</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
